var FilterTypes;
(function (FilterTypes) {
    FilterTypes["GenericMultiSelect"] = "GenericMultiSelect";
    FilterTypes["SearchSelect"] = "searchSelect";
    FilterTypes["TreeMultiSelect"] = "treeMultiSelect";
    FilterTypes["GroupedMultiSelect"] = "groupedMultiSelect";
    FilterTypes["DateRangePicker"] = "dateRangePicker";
    FilterTypes["BooleanSelect"] = "booleanSelect";
    FilterTypes["Hidden"] = "hidden";
})(FilterTypes || (FilterTypes = {}));
export default FilterTypes;
